import { IRouter } from '../type';
export const Service: IRouter[] = [
  {
    path: '/service',
    name: 'service',
    meta: { title: '在线下单', icon: 'el-icon-s-home' },
    hidden: false,
    component: () => import('@/views/AllService/Service.vue')
  },
  {
    path: '/service_by_tool',
    name: 'serviceByTool',
    meta: { title: '智能服务', icon: 'el-icon-s-home' },
    hidden: false,
    component: () => import('@/views/AllService/Service.vue')
  },
];
